<div id="context-menu" [ngStyle]="style">
  <span (click)="contextMenuItemClick.emit('view')"><i class="fa-regular fa-circle-info mr-2"></i> {{ 'schedule.contextMenu.view' | translate}} </span>
  <hr />
  <span (click)="contextMenuItemClick.emit('duplicate')"><i class="fa-regular fa-clone mr-2"></i> {{ 'schedule.contextMenu.duplicate' | translate}} </span>
</div>
